import { Button, Modal, Col } from "react-bootstrap";
import team0 from "../../assets/images/team/team-0-modal.jpg";
import useLang from "hooks/useLang";

const ModalSabar = (props) => {
  const { lang } = useLang();
  return (
    <Modal
      id="modal-detail"
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body>
        <div id="modal-detail-img">
          <Col lg={6} sm={6} className="center">
            <div className="member box-tab">
              <div className="pic owner effect">
                <img src={team0} alt="" />
              </div>
              <h4>Sabar Sitorus</h4>
              <span>Chief Visionary Officer (CVO)</span>
            </div>
          </Col>
        </div>
        <p style={{ textAlign: "justify" }}>{lang.our_team.card_1_detail}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalSabar;
